export default __webpack_public_path__ + "static/media/Heart-outline-add.a5e9983b.gif";